<template>
  <mdb-container v-if="details" class="gp-has-header" fluid>
    <div aria-label="Tools" class="gp-fixed-action-btn" title="Tools">
      <a class="btn-floating btn-primary ripple-parent" @click.prevent="loadDetails">
        <mdb-icon fal icon="repeat"/>
      </a>
    </div>
    <mdb-card v-if="tabLinks.length == 0">
      <mdb-card-body>
        <div>No Action Needed!</div>
      </mdb-card-body>
    </mdb-card>
    <div class="text-left">
      <mdb-btn icon="tachometer" @click="$router.push('/admin/dashboard')">Admin Dashboard</mdb-btn>
    </div>
    <mdb-tabs v-if="dataLoaded && tabLinks.length > 0" :active="activeTab" :links="tabLinks"
              card
              class="mb-5"
              tabs
    >
      <div slot="Payment Errors" v-if="details.paymentErrors">
        <mdb-card class="mb-4">
          <mdb-card-body>
            <mdb-row>
              <div v-for="(u,i) in details.paymentErrors" :key="i" class="mb-4 col-md-3 d-flex align-self-stretch">
                <mdb-card>
                  <mdb-card-header>
                    <h5>
                      <avatar :avatar="u.avatar"/>
                      <b>{{ u.name }}</b>
                      <mdb-badge color="warning">{{u.balanceCurrencySymbol}}{{ u.balance | formatNumber }} ({{u.balanceCurrencyCode}})</mdb-badge>
                    </h5>
                  </mdb-card-header>
                  <mdb-card-body>
                    <br/>
                    Username <b>
                    <router-link :to="'/users/'+u.userId">{{ u.username }}</router-link>
                  </b> <br/>
                    {{ u.email }} <br/>
                    <b>Billed</b> {{ u.lastBilled }} <br/>
                    <b>Paid Through </b>{{ u.paidThrough }} <br/>
                    <mdb-btn color="success" icon="eye" rounded size="sm" @click="viewError(u)">View Error</mdb-btn>
                    <mdb-btn color="warning" icon="eye" rounded size="sm" @click="execPayment(u.chargeId)">Retry Charge</mdb-btn>
                    <div style="clear:both;"/>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </mdb-row>
          </mdb-card-body>
        </mdb-card>
      </div>
      <div slot="Ready to Charge" v-if="details.readyToCharge">
        <mdb-card class="mb-4">
          <mdb-card-body>
            <mdb-row>
              <mdb-card class="mb-4">
                <mdb-card-body class="text-info">
                  The following users will be charged in tonight's processing. To force a charge
                  immediately, hit the "charge now" button.
                </mdb-card-body>
              </mdb-card>
            </mdb-row>
            <mdb-row>
              <div v-for="(u,i) in details.readyToCharge" :key="i" class="mb-4 col-md-3 d-flex align-self-stretch">
                <mdb-card>
                  <mdb-card-header>
                    <h5>
                      <avatar :avatar="u.avatar"/>
                      <b>{{ u.name }}</b>
                      <mdb-badge color="warning">{{u.currencySymbol}} {{ u.balance | formatNumber }} {{u.currencyCode}}</mdb-badge>
                    </h5>
                  </mdb-card-header>
                  <mdb-card-body>
                    <br/>
                    Username <b>
                    <router-link :to="'/users/'+u.userId">{{ u.username }}</router-link>
                  </b> <br/>
                    {{ u.email }} <br/>
                    <b>Billed</b> {{ u.lastBilled }} <br/>
                    <b>Paid Through </b>{{ u.paidThrough }} <br/>
                    <b>Charge Date </b>{{ u.chargeDate }} <br/>
                    <mdb-btn v-if="u.subscriptionId" icon="pencil" rounded size="sm" @click="manageSubscription(u)">Manage</mdb-btn>
                    <mdb-btn color="warning" icon="credit-card-front" rounded size="sm" @click="execPayment(u.chargeId)">Charge Now</mdb-btn>
                    <div style="clear:both;"/>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </mdb-row>
          </mdb-card-body>
        </mdb-card>
      </div>
      <div slot="Subscription Issues" v-if="details.subscriptionIssues">
        <mdb-card class="mb-4">
          <mdb-card-body>
            <mdb-row>
              <div v-for="(u,i) in details.subscriptionIssues" :key="i" class="mb-4 col-md-3 d-flex align-self-stretch">
                <mdb-card>
                  <mdb-card-header>
                    <h5>
                      <avatar :avatar="u.avatar"/>
                      <b>{{ u.name }}</b>
                    </h5>
                  </mdb-card-header>
                  <mdb-card-body>
                    <br/>
                    Username <b>
                    <router-link :to="'/admin/subscription/'+u.subscriptionId + '?return=/admin/billing'">{{ u.username }}</router-link>
                  </b> <br/>
                    {{ u.email }} <br/>
                    <div class="text-info">{{u.message}}</div>
                    <b>Paid Through: </b>{{ u.paidThrough }} <br/>
                    <mdb-btn color="success" icon="minus-circle" rounded size="sm" @click="clearIssue(u)">Clear Issue</mdb-btn>
                    <div style="clear:both;"/>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </mdb-row>
          </mdb-card-body>
        </mdb-card>
      </div>


      <div slot="Need To Notify" v-if="details.needToNotify">
        <mdb-card class="mb-4">
          <mdb-card-body>
            <mdb-row>
              <div v-for="(u,i) in details.needToNotify" :key="i" class="mb-4 col-md-3 d-flex align-self-stretch">
                <mdb-card>
                  <mdb-card-header>
                    <h5>
                      <avatar :avatar="u.avatar"/>
                      <b>{{ u.name }}</b>
                      <mdb-badge color="warning">${{ u.balance }}</mdb-badge>
                    </h5>
                  </mdb-card-header>
                  <mdb-card-body>
                    <br/>
                    Username <b>
                    <router-link :to="'/users/'+u.id">{{ u.username }}</router-link>
                  </b> <br/>
                    {{ u.email }} <br/>
                    <b>Billed</b> {{ u.lastBilled }} <br/>
                    <b>Paid Through </b>{{ u.paidThrough }} <br/>
                    <b>Last Reminded </b>{{ u.reminderSent }} <br/>
                    <mdb-btn icon="bell-on" rounded
                             size="sm" @click="getRemindText(u)">Remind Now
                    </mdb-btn>
                    <div style="clear:both;"/>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </mdb-row>
          </mdb-card-body>
        </mdb-card>
      </div>
      <div slot="Expired Free Plans" v-if="details.expiredFreePlan">
        <mdb-card class="mb-4">
          <mdb-card-body>
            <mdb-row>
              <div v-for="(u,i) in details.expiredFreePlan" :key="i" class="mb-4 col-md-3 d-flex align-self-stretch">
                <mdb-card>
                  <mdb-card-header>
                    <h5>
                      <avatar :avatar="u.avatar"/>
                      <b>{{ u.name }}</b>
                    </h5>
                  </mdb-card-header>
                  <mdb-card-body>
                    <b>Billed</b> {{ u.lastBilled }} <br/>
                    <b>Paid Through </b>{{ u.paidThrough }} <br/>
                    <mdb-btn color="success" icon="pencil" rounded size="sm" @click="$router.push('/users/' + u.id)">
                      Edit Profile
                    </mdb-btn>
                    <div style="clear:both;"/>
                  </mdb-card-body>
                </mdb-card>
              </div>
            </mdb-row>
          </mdb-card-body>
        </mdb-card>
      </div>
    </mdb-tabs>
    <yes-no-modal v-if="deleteChargeModal" @no="deleteChargeModal=false" @yes="doDeleteCharge()"/>
    <mdb-modal v-if="showPaymentErrorModal" @close="showPaymentErrorModal = false">
      <mdb-modal-header :close="true" center class="secondary-color"><h5>Payment Error Details</h5></mdb-modal-header>
      <mdb-modal-body class="text-left">
        {{ paymentError.failure }}
      </mdb-modal-body>
    </mdb-modal>
    <mdb-modal v-if="adhocChargeModal" size="lg" @close="adhocChargeModal = false">
      <mdb-modal-header :close="true" center class="secondary-color"><h5>Charge User</h5></mdb-modal-header>
      <mdb-modal-body class="text-left">
        <mdb-input type="number" :step="0.01"  v-model="currentIssue.proratedAmount" placeholder="Charge Amount" label="Amount"/>
        <mdb-input type="text" v-model="currentIssue.description" placeholder="Charge Reason" label="Charge Reason"/>
        <mdb-btn color="success" icon="credit-card" @click="adhocCharge">Charge Now</mdb-btn>
        <mdb-btn color="warning" icon="times-circle" @click="adhocChargeModal =false">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>
    <mdb-modal v-if="paymentReminderModal" size="lg" @close="paymentReminderModal = false">
      <mdb-modal-header :close="true" center class="secondary-color"><h5>Reminder Text</h5></mdb-modal-header>
      <mdb-modal-body class="text-left">
        <editor v-model="remindText" :init="editorConfig"/>
        <mdb-btn color="success" icon="mail" @click="sendReminder">Send Now</mdb-btn>
        <mdb-btn color="warning" icon="times-circle" @click="paymentReminderModal =false">Cancel</mdb-btn>
      </mdb-modal-body>
    </mdb-modal>

  </mdb-container>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbTabs
} from "mdbvue";
import Avatar from "../common/Avatar";
import UserChip from "../common/UserChip";
import YesNoModal from "../common/YesNoModal";
import editor from '@tinymce/tinymce-vue'

export default {
  name: "Billing-Dashboard",
  components: {
    YesNoModal,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbChip,
    mdbBtn,
    mdbBadge,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbTabs,
    mdbIcon,
    mdbInput,
    Avatar,
    UserChip,
    editor
  },
  data() {
    return {
      details: null,
      deleteChargeModal: false,
      deleteCandidate: null,
      executingCount: 0,
      showPaymentErrorModal: false,
      paymentError: null,
      remindText: "",
      paymentReminderModal: false,
      remindUser: null,
      tabLinks: [],
      dataLoaded: false,
      tabWithData: false,
      sectionsLoaded: 0,
      currentIssue: null,
      adhocChargeModal : false,
      activeTab: 0,
      editorConfig: {
        browser_spellcheck: true,
        branding: false,
        plugins: ["image", "link", "code", "paste", "table", "lists"],
        toolbar: ["undo redo cut copy paste bold italic underline numlist bullist fontsizeselect | alignleft alignright aligncenter | styleselect | image link unlink code "],
        file_picker_callback: this.myFileBrowser,
        image_advtab: true,
        style_formats_merge: true,
        paste_as_text: true,
        relative_urls: false,
        remove_script_host: false,
        height: 400
      }
    };
  },
  filters: {
    formatNumber: function (val) {
      if (!val) return ""
      return val.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    }
  },
  mounted() {
    document.title = "Billing Dashboard"
    this.loadDetails()
  },
  watch: {
    sectionsLoaded: function (n) {
      if (n >= 4 && this.tabWithData) {
        this.$nextTick().then(() => {
          //force resize so new content shows
          this.activeTab = 5
          this.dataLoaded = true
          this.$nextTick().then(() => {
            this.activeTab = 0
          })
        })
      }
    }
  },
  computed: {
    settings() {
      return this.$store.state.settings
    }
  },
  methods: {
    viewError(u) {
      this.paymentError = u
      this.showPaymentErrorModal = true
    },
    emptyDetails() {
      this.tabLinks = []
      this.dataLoaded = false
      this.tabWithData = false
      this.sectionsLoaded = 0
      this.details = {
        readyToCharge: [], needToNotify: [], expiredFreePlan: [], paymentErrors: [], subscriptionIssues: []
      }
    },
    loadDetails() {
      this.emptyDetails()
      this.getSection("readyToCharge")
      this.getSection("paymentErrors")
      this.getSection("expiredFreePlan")
      this.getSection("needToNotify")
      this.getSection("subscriptionIssues")
      //{text: 'Payment Errors'}, {text: 'Ready to Charge'}, {text: 'Expired Plans'}, {text: 'Other'}
    },
    getSection(query) {
      api.get("/admin/dashboard?q=" + query).then(
        (results) => {
          this.details[query] = results.data
          if (this.details[query].length > 0) {
            this.tabWithData = true
            if (query == 'readyToCharge') this.tabLinks.push({text: "Ready to Charge"})
            if (query == 'paymentErrors') this.tabLinks.push({text: "Payment Errors"})
            if (query == 'expiredFreePlan') this.tabLinks.push({text: "Expired Free Plans"})
            if (query == 'needToNotify') this.tabLinks.push({text: "Need To Notify"})
            if (query == 'subscriptionIssues') this.tabLinks.push({text: "Subscription Issues"})
          }
        },
        (error) => {
          if (error.response.status == 403) {
            this.$router.push("/403")
            return;
          }
          this.$notify.error({message: error.response.data, timeOut: 20000})

        }).then(() => {
            this.$nextTick().then(() => {
              this.sectionsLoaded++
            })
          }
        )
    },
    resizeTabs() {

    },
    manageSubscription(charge) {
      this.$router.push("/admin/subscription/" + charge.subscriptionId + "?return=/admin/billing")
    },
    chargeIssue(i) {
      this.currentIssue = i
      this.currentIssue.proratedAmount = Math.round( this.currentIssue.proratedAmount * 100) / 100
      this.currentIssue.description = "Prorated Subscription"
      this.adhocChargeModal = true
    },
    clearIssue(i) {
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/clearIssue", i).then(
        (results) => {
          let loc = this.details.subscriptionIssues.indexOf(i)
          this.currentIssue = null
          this.details.subscriptionIssues.splice(loc,1)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    adhocCharge() {
      this.adhocChargeModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/chargeIssue", this.currentIssue).then(
        () => {
          let loc = this.details.subscriptionIssues.indexOf(this.currentIssue)
          this.currentIssue = null
          this.details.subscriptionIssues.splice(loc,1)
        },
        (error) => {
          this.adhocChargeModal = true
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    execPayment(chargeId) {
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/execCharge", {id: chargeId}).then(
        (results) => {
          this.loadDetails()
        },
        (error) => {
          if (error.response.status == 403) {
            this.$router.push("/403")
          }
          this.$notify.error({message: error.response.data, timeOut: 20000})

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    getRemindText(user) {
      this.$store.dispatch("setExecuting", true)
      api.get("/admin/remindText/" + user.id).then(
        (results) => {
          this.remindText = results.data.remindText
          this.paymentReminderModal = true
          this.remindUser = user
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    sendReminder() {
      this.paymentReminderModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/admin/paymentReminder", {userId: this.remindUser.id, remindText: this.remindText}).then(
        (results) => {
          this.remindUser.reminderSent = results.data.reminderSent
          this.remindUser = null
          this.remindText = null
        },
        (error) => {
          if (error.response.status == 403) {
            this.$router.push("/403")
          }
          this.$notify.error({message: error.response.data, timeOut: 20000})
          this.paymentReminderModal = true

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }

  }

}
;
</script>
<style scoped>
@media screen and (max-width: 499px ) {
  .gp-fixed-action-btn {
    position: fixed;
    right: 5px;
    bottom: 10px;
    z-index: 998;
    margin-bottom: 0;
    overflow: hidden;
    height: 100px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
  }
}

@media screen and (min-width: 500px ) {
  .gp-fixed-action-btn {
    position: fixed;
    right: 35px;
    top: 100px;
    z-index: 998;
    margin-bottom: 0;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: end;
    -ms-flex-align: end;
    align-items: flex-end;
    padding: 15px 15px 15px 15px;
    padding-bottom: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
